import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Button, Col, Input, Row, Spinner } from "reactstrap";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const AddLocalizationForm = ({ labels, formikProps, onTranslateClickHandler, translationLoading, lastTranslatedField, isAddOrEdit }) => {
	const { t, i18n } = useTranslation();
	const { screens } = useSelector((state) => state.Localization);

	// Destructure from formikProps for easier access
	const { values, errors, touched, handleChange, handleBlur, setFieldValue } = formikProps;
	
	const renderField = (item) => {
		const isDisabled = typeof item.disabled === 'function' ? item.disabled(isAddOrEdit) : !!item.disabled;
		const fieldValue = values[item.name] ?? "";
	
		switch (item.fieldName) {
		  case "text-box":
			return (
				<Input
				  type={"text"}
				  id={item.name}
				  name={item.name}
				  placeholder={t(item.placeholder || item.labelName)}
				  value={fieldValue}
				//   onChange={(e) => {
				// 	const inputValue = e.target.value;
					
				// 	// If it's RoleName field, allow only letters and spaces
				// 	if (item.name === "LabelKey" ) {
				// 		const cleanedValue = inputValue.replace(/[^A-Za-z\s]/g, '');
				// 		setFieldValue(item.name, cleanedValue);
				// 	} else {
				// 		handleChange(e);
				// 	}
				//   }}
				  onChange={(e) => {
						handleChange(e);
	              }}
				  maxLength={item.maxLength} 
				  minLength={item.minLength}
				  onBlur={handleBlur}
				  className="form-control"
				  disabled={isDisabled}
				  invalid={touched[item.name] && !!errors[item.name]}
				  required={item.required}
				/>
			);
		
		  case "email-box":
			return (
			  <Input
				type={"email"}
				id={item.name}
				name={item.name}
				placeholder={t(item.placeholder || item.labelName)}
				value={fieldValue}
				onChange={handleChange}
				onBlur={handleBlur}
				className="form-control"
				disabled={isDisabled}
				invalid={touched[item.name] && !!errors[item.name]}
				required={item.required}
			  />
			);
	
		  case "number":
			return (
			  <Input
				type="tel"
				id={item.name}
				name={item.name}
				placeholder={t(item.placeholder || item.labelName)}
				value={fieldValue}
				onChange={handleChange} 
				onBlur={handleBlur}
				className="form-control"
				disabled={isDisabled}
				// maxLength={maxLength}
				invalid={touched[item.name] && !!errors[item.name]}
				required={item.required}
			  />
			);
	
		  case "text-box-translate":
			return (
			  <div className="input-group"> {/* Using input-group for Bootstrap styling */}
				<Input
				  type={"text"}
				  id={item.name}
				  name={item.name}
				  placeholder={t(item.placeholder || item.labelName)}
				  value={fieldValue}
				  onChange={handleChange}
				  onBlur={handleBlur}
				  className="form-control"
				  disabled={isDisabled}
				  invalid={touched[item.name] && !!errors[item.name]}
				  required={item.required}
				/>
				{onTranslateClickHandler && item.translateTo && (
				  <Button
					type="button"
					onClick={() => onTranslateClickHandler(item.translateTo, fieldValue, setFieldValue, item.name)} // Pass item.name as sourceFieldName
					disabled={!fieldValue || !fieldValue.trim() || translationLoading || isDisabled} // Disable if any translation is loading or field is disabled
				  >
                    {translationLoading && lastTranslatedField === item.name ? (
                      <Spinner size="sm" />
                    ) : (
                      <i className="ri-translate"></i>
                    )}
                  </Button>
				)}
			  </div>
			);

		  case "ckeditor-translate":
			return (
				<div className="input-group">
					<div className="ck-editor-container">
						<CKEditor
							editor={ClassicEditor}
							data={fieldValue}
							onChange={(event, editor) => {
								const data = editor.getData();
								setFieldValue(item.name, data);
							}}
							onBlur={() => handleBlur({ target: { name: item.name } })}
						/>
					</div>
					{onTranslateClickHandler && item.translateTo && (
						<Button
							type="button"
							onClick={() => onTranslateClickHandler(item.translateTo, fieldValue, setFieldValue, item.name)}
							disabled={!fieldValue || !fieldValue.trim() || translationLoading || isDisabled}
						>
							{translationLoading && lastTranslatedField === item.name ? (
								<Spinner size="sm" />
							) : (
								<i className="ri-translate"></i>
							)}
						</Button>
					)}
				</div>
			);

		  case 'screen-selection-dropdown':
				return (
					<Input
						type="select"
						id={item.name}
						name={item.name}
						value={fieldValue}
						onChange={handleChange}
						onBlur={handleBlur}
						className="form-control"
						disabled={isDisabled}
						invalid={touched[item.name] && !!errors[item.name]}
						>
						<option value="">{t("SelectScreen")}</option>
						{screens.map((screenItem) => (
							<option key={screenItem.ID} value={screenItem.ID}>
								{i18n?.language === 'en' ? screenItem.ScreenNameEn : screenItem.ScreenNameAr}
							</option>
						))}
					</Input>
				);

	      case "cms-text-html":
		    return (
				<CKEditor
					editor={ClassicEditor}
					data={fieldValue}
					onChange={(event, editor) => {
						const data = editor.getData();
						setFieldValue(item.name, data);
					}}
					onBlur={() => handleBlur({ target: { name: item.name } })}
				/>
			);
		  default:
			return null;
		}
	  };
	
	  return (
		  
		  <Row>
		  {labels.map((item) => {
			  return (
			  <Col sm={6} key={item.name}>
				<div className="mb-3">
					<label htmlFor={item.name} className="col-form-label">
					  {t(item.labelName)}
					  {item.required && <span className="text-danger"> *</span>}
					</label>
				  {/* Render the field */}
				  {renderField(item)}
				  {/* Display error for the main field */}
				  {touched[item.name] && errors[item.name] && (
					<div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>{t(errors[item.name])}</div>
				  )}
				</div>
			  </Col>
			);
		  })}
		</Row>
	  );
}

export default AddLocalizationForm